module.exports = __webpack_public_path__ + "img/radio-inactive.svg";